import { fetchOptions } from './csrf'

export interface DescriptionTemplate {
  id: string
  name: string
  content: string
  position: number
  is_default: boolean
  created_at: string
  updated_at: string
}

interface TemplatesResponse {
  description_templates: DescriptionTemplate[]
}

interface TemplateResponse {
  description_template: DescriptionTemplate
}

interface ErrorResponse {
  errors: string[]
}

export const descriptionTemplatesApi = {
  async list(): Promise<DescriptionTemplate[]> {
    const response = await fetch('/api/v1/settings/description-templates', fetchOptions())
    if (!response.ok) throw new Error('Failed to load templates')
    const data: TemplatesResponse = await response.json()
    return data.description_templates
  },

  async create(params: { name: string; content: string; is_default?: boolean }): Promise<DescriptionTemplate> {
    const response = await fetch('/api/v1/settings/description-templates', {
      ...fetchOptions('POST'),
      body: JSON.stringify({ description_template: params }),
    })
    if (!response.ok) {
      const data: ErrorResponse = await response.json().catch(() => ({ errors: ['Failed to create template'] }))
      throw new Error(data.errors.join(', '))
    }
    const data: TemplateResponse = await response.json()
    return data.description_template
  },

  async update(id: string, params: Partial<{ name: string; content: string; is_default: boolean }>): Promise<DescriptionTemplate> {
    const response = await fetch(`/api/v1/settings/description-templates/${id}`, {
      ...fetchOptions('PUT'),
      body: JSON.stringify({ description_template: params }),
    })
    if (!response.ok) {
      const data: ErrorResponse = await response.json().catch(() => ({ errors: ['Failed to update template'] }))
      throw new Error(data.errors.join(', '))
    }
    const data: TemplateResponse = await response.json()
    return data.description_template
  },

  async destroy(id: string): Promise<void> {
    const response = await fetch(`/api/v1/settings/description-templates/${id}`, fetchOptions('DELETE'))
    if (!response.ok) throw new Error('Failed to delete template')
  },

  async reorder(ids: string[]): Promise<DescriptionTemplate[]> {
    const response = await fetch('/api/v1/settings/description-templates/reorder', {
      ...fetchOptions('PATCH'),
      body: JSON.stringify({ ids }),
    })
    if (!response.ok) throw new Error('Failed to reorder templates')
    const data: TemplatesResponse = await response.json()
    return data.description_templates
  },
}
